const intro = {
  eyebrow: '02 — Voor je begint',
  titleLead: 'Kort voordat',
  titleAccent: 'je start.',
  subDesktop:
    'Je krijgt vragen over hoe jij werkt en energie krijgt. Kies steeds wat het meest bij jou past — niet wat goed klinkt.',
  subMobile:
    'Je krijgt vragen over hoe jij werkt. Kies steeds wat het meest bij jou past.',

  cards: [
    {
      title: 'Hoe kies je?',
      text: "Kies wat het meest op jou lijkt. Twijfel je? Ga voor wat het sterkst voelt — niet wat 'goed' klinkt.",
    },
    {
      title: 'Meerdere passend?',
      text: "Normaal. Je bent geen hokje. Het resultaat laat juist ook je mix van persona's zien.",
    },
    {
      title: 'Hoe lang duurt het?',
      text: 'Negen vragen, ongeveer vijf minuten. Niets voorbereiden nodig. Gewoon eerlijk invullen.',
    },
  ],

  actionStrong: 'Belangrijk:',
  actionText:
    'dit is geen goed-fout test. Het gaat om wat het meest natuurlijk bij jou past.',
  btnStart: 'Start met de vragen',
  btnBack: 'Terug',
};

export default intro;
